import React, {
  ForwardRefExoticComponent,
  PropsWithChildren,
  ReactElement,
} from "react";

import useWindowSize from "../../../hooks/use-window-size";

export type ContentListProps = {};

export interface ContentListRef extends ForwardRefExoticComponent<ReactElement> {
  refetch(): void;
}

export function ContentList(
  props: PropsWithChildren<ContentListProps>,
): ReactElement {
  const { children } = props;

  const listHeight = useWindowSize().height;

  return (
    <div
      style={{
        minHeight: `${listHeight / 2 - 300}px`,
      }}
      className="p-[28px] h-full min-h-full overflow-auto"
    >
      {children}
    </div>
  );
}
